import React from 'react';
import PropTypes from 'prop-types';

import { propertyArea } from 'helpers/FormattedSpecifications';
import { translate, translatePlural } from 'helpers/Translate';
import { getHabitationValuationUrl } from 'helpers/Estima';

/**
 * Limit of habitations to display.
 * @type {Number}
 */
const MAX_HABITATIONS = 3;

const HabitationsList = ({ habitations }) => {
    if (!habitations || habitations.length === 0) {
        return null;
    }

    return (
        <div className="habitations-list" data-habitations>
            <div className="text--h4">
                {translatePlural(
                    'Votre dernière estimation',
                    'Vos dernières estimations',
                    habitations.length,
                )}
            </div>

            <ul className="habitations-list__list no-margin">
                {habitations.slice(0, MAX_HABITATIONS).map((habitation) => (
                    <li className="margin-top" key={habitation.id}>
                        <a
                            className="no-underline habitations-list__link"
                            href={getHabitationValuationUrl(habitation.id)}
                        >
                            <span className="icon-room margin-right habitations-list__marker" />
                            <span className="pointer-event underline--hover">
                                <span className="habitations-list__address">
                                    {habitation.address.name}, {habitation.city.zip}&nbsp;
                                    {habitation.city.name}
                                </span>
                                <span className="habitations-list__area">
                                    &nbsp;-&nbsp;<strong>{propertyArea(habitation.area)}</strong>
                                </span>
                            </span>
                        </a>
                    </li>
                ))}
            </ul>

            {habitations.length > MAX_HABITATIONS && (
                <a
                    className="btn btn--secondary btn--small margin-top-double"
                    href={getHabitationValuationUrl()}
                >
                    {translate('Voir toutes mes estimations')}
                </a>
            )}
        </div>
    );
};

HabitationsList.displayName = 'HabitationsList';

HabitationsList.propTypes = {
    habitations: PropTypes.arrayOf(PropTypes.shape({})),
};

/**
 * HabitationsList Functional Component.
 */
export default HabitationsList;
